module.exports = __webpack_public_path__ + "static/media/wolffox6_preview.a6e2e1bb.jpg";